import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EmbryoDetail from '../../Embryo/EmbryoDetail/EmbryoDetail';
import { fetchEmbryo, fetchClusters } from '../../../utils/api';
import clusterColorClass from '../../../utils/clusterColorClass';

let clusterPromise = null;
let clusterCache = null;


function clustersByClassification(clusters) {
	return clusters.reduce((acc, cluster) => ({
		...acc,
		[cluster.classification]: cluster,
	}), {});
}


export default class ApiEmbryoDetail extends Component {
	static propTypes = {
		id: PropTypes.number.isRequired,
		onLoad: PropTypes.func,
	};

	static defaultProps = {
		onLoad: null,
	};

	loadingId = null;

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.id !== prevState.prevId) {
			return {
				embryoData: null,
				prevId: nextProps.id,
			};
		}

		return null;
	}

	constructor() {
		super();
		if (clusterPromise === null) {
			clusterPromise = fetchClusters().then(clustersByClassification);
			clusterPromise.then((clusterData) => {
				clusterCache = clusterData;
			});
		}

		this.state = {
			embryoData: null,
			clusterData: clusterCache,
			prevId: null,
		};
	}

	componentDidMount() {
		const { id } = this.props;
		this.loadEmbryo(id);
		if (clusterCache !== null) {
			this.setState({ clusterData: clusterCache });
		} else {
			clusterPromise.then((clusterData) => {
				if (this.loadingId !== null) {
					this.setState({ clusterData });
				}
			});
		}
	}

	componentDidUpdate() {
		const { embryoData } = this.state;

		if (embryoData === null) {
			const { id } = this.props;
			this.loadEmbryo(id);
		}
	}

	componentWillUnmount() {
		this.loadingId = null;
	}

	loadEmbryo(id) {
		if (id === this.loadingId) {
			// already fetching
			return;
		}

		this.loadingId = id;
		fetchEmbryo(id).then((embryoData) => {
			const { onLoad } = this.props;
			if (id === this.loadingId) {
				this.setState({ embryoData }, onLoad);
			}
		});
	}

	render() {
		const { embryoData, clusterData } = this.state;
		const { id, ...other } = this.props;

		if (embryoData === null || clusterData === null) {
			return null;
		}

		const cluster = clusterData[embryoData.cluster] || null;

		return (
			<EmbryoDetail
				embryo={embryoData}
				cluster={cluster}
				detailClasses={`wrap${clusterColorClass(cluster)} is-colored-invert`}
				{...other}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./frontend/components/Api/ApiEmbryoDetail/ApiEmbryoDetail.js